export const CustomerSignatoryState = {
    Authorised: "Authorised",
    Rejected: "Rejected",
}